export default __webpack_public_path__ + "static/media/stacked_rooms_white.3e8eab9f.svg";